import React from 'react';
import {
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
import CustomLink from '../../CustomLink/CustomLink';
import StoryblokLinkProvider from '../../Utils/StoryblokLinkProvider/StoryblokLinkProvider';
import { MainNavLink } from '../MainNav/MainNav.interface';
import SideNavAccordionHeading from './SideNavAccordionHeading';

const MainNavAccordionItem: React.FC<MainNavLink> = ({
  label,
  link,
  dropdown,
  ...props
}) => {
  return (
    <AccordionItem key={props._uid} uuid={props._uid} className="group w-full">
      <AccordionItemHeading>
        <AccordionItemButton className="focus:ring-0 focus:outline-none">
          <AccordionItemState>
            {(state) =>
              state && (
                <SideNavAccordionHeading
                  label={label}
                  link={link}
                  state={state}
                />
              )
            }
          </AccordionItemState>
        </AccordionItemButton>
      </AccordionItemHeading>

      <AccordionItemPanel className="px-10 border-b border-border/light pb-6 mb-2">
        {dropdown &&
          !!dropdown.length &&
          dropdown.map(
            ({
              primary_heading,
              primary_links,
              secondary_heading,
              secondary_links,
              cta,
              _uid,
            }) => (
              <div key={_uid}>
                {primary_heading && (
                  <p className="text-text/body-accent text-sm font-normal uppercase pb-4 pt-6">
                    {primary_heading}
                  </p>
                )}
                <ul className="space-y-2 border-border/light border-b pb-6">
                  {primary_links?.map(({ link, label, _uid }) => (
                    <li key={_uid}>
                      <CustomLink
                        url={link?.cached_url}
                        label={label}
                        className="nav-link font-normal text-text/body hover:text-text/body-accent block py-2"
                      >
                        {label}
                      </CustomLink>
                    </li>
                  ))}
                </ul>
                {secondary_heading && (
                  <p className="text-text/body-accent text-sm font-normal uppercase pt-8 pb-6">
                    {secondary_heading}
                  </p>
                )}
                <ul className="space-y-2 pb-6">
                  {secondary_links?.map(({ link, heading, _uid }) => (
                    <li key={_uid}>
                      <StoryblokLinkProvider
                        link={link}
                        render={(link) => (
                          <CustomLink
                            url={link}
                            label={heading}
                            className="nav-link flex items-center text-text/body prose-p:hover:text-text/body-accent text-sm space-x-4 py-2"
                          >
                            <div className="min-h-[40px] min-w-[40px] flex justify-center items-center border rounded-full border-[#009bef] bg-[#E5F4F9]">
                              <span className="block h-[24px] w-[24px] bg-[url('/svgs/star-outline.svg')] bg-no-repeat" />
                            </div>
                            <div>
                              <p className="font-bold">{heading}</p>
                            </div>
                          </CustomLink>
                        )}
                      />
                    </li>
                  ))}
                </ul>
                {!!cta?.length && cta[0] && (
                  <StoryblokLinkProvider
                    link={cta[0].link}
                    render={(link) => (
                      <div className="flex items-center space-x-2">
                        <CustomLink
                          url={link}
                          label={dropdown[0]?.cta[0].label}
                          className="text-text/body-primary font-bold flex items-center transition-all"
                        >
                          {dropdown[0]?.cta[0].label}
                          <span className="block h-[24px] w-[24px] bg-[url('/svgs/arrow.svg')] bg-no-repeat ml-2" />
                        </CustomLink>
                      </div>
                    )}
                  />
                )}
              </div>
            )
          )}
      </AccordionItemPanel>
    </AccordionItem>
  );
};

export default MainNavAccordionItem;
